<div class="weightage-container" fxLayout="column" fxLayoutAlign="start stretch">
	<div fxLayout="row" fxLayoutAlign="start center">
		<app-chips fxFlex="0 0 auto" type="progressive" background="var(--secondary-four)" (click)="triggered()"
			[data]="{title: field?.fieldCaption, progress: progress + '%', bufferColor: 'transparent', progressColor: 'var(--primary-two)', expected: expected + '%'}"
			class="cursor-pointer" appClickOutSide [template]="sliderEl" [readonly]="field?.isReadonly"
			[position]="'top start'" [close]="closeTemplate" (isOpen)="isOpen($event)">
		</app-chips>
		<ng-container *ngIf="field?.additionalMetaData?.removable">
			<mat-icon #actionEl (click)="remove(actionEl)" class="cursor-pointer remove-chip">close</mat-icon>
		</ng-container>
	</div>
	<div class="slider-process slider-process-bg" fxLayout="row" fxLayoutAlign="center stretch" fxLayoutGap="10px" #sliderEl
		(mouseleave)="leaveSlider()" (mouseover)="focusSlider()">
		<!-- <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="5px"> -->
		<mat-slider class="slider" fxLayoutAlign="center center" [(ngModel)]="value"
			[max]="(gfService.typeOf(field?.additionalMetaData?.maxWeightage) === 'object') ? field?.additionalMetaData?.maxWeightage?.length - 1 : field?.additionalMetaData?.maxWeightage"
			color="primary" (change)="sliderChange($event)" (input)="sliderInputChange($event)">
		</mat-slider>
		<ng-container *ngIf="field?.additionalMetaData?.maxWeightage?.length">
			<span fxFlex="0 1 auto" fxLayoutAlign="center center" class="level-hint cursor-pointer" (click)="showHelp()">
				{{field?.additionalMetaData?.maxWeightage[value]?.value}}
			</span>
			<ng-container *ngIf="field?.additionalMetaData?.showHelp">
				<div fxLayout="row" fxLayoutAlign="center center">
					<mat-icon class="help-icon cursor-pointer" (click)="showHelp()">help</mat-icon>
				</div>
			</ng-container>
		</ng-container>
		<!-- </div> -->
	</div>
	<mat-hint *ngIf="(control.untouched || control.valid) && ![null, undefined, ''].includes(field.fieldHelpText)"
		[@slide]="{ value: 'rightIn', params: { colorFrom:'rgba(0, 0, 0, 0.6)', translateFrom: 'translateY(20%)',inTime:'200ms' }}">
		{{field.fieldHelpText}}</mat-hint>
</div>
